// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TrustedFeatures_grid__vkqBz {
  display: grid;
  gap: 1.25rem;
  grid-template-columns: 1fr;
  text-align: center;
}
@media (min-width: 768px) {
  .TrustedFeatures_grid__vkqBz {
    grid-template-columns: repeat(3, 1fr);
    text-align: left;
    gap: 0;
  }
}

.TrustedFeatures_trustedFeatures__YOWxK p {
  font-size: var(--font-normal);
}

.TrustedFeatures_item__AiY\\+l + .TrustedFeatures_item__AiY\\+l {
  border-top: 1px solid var(--color-fondo-claro-200);
  padding-top: 1rem;
}
.TrustedFeatures_item__AiY\\+l h6 {
  margin: 0 0 0.5rem;
  font-weight: 700;
  color: var(--color-secundario);
}
.TrustedFeatures_item__AiY\\+l p {
  margin: 0;
  color: var(--color-secundario);
  font-size: 0.95rem;
}
@media (min-width: 768px) {
  .TrustedFeatures_item__AiY\\+l + .TrustedFeatures_item__AiY\\+l {
    border-top: 0;
    padding-top: 0;
    border-left: 1px solid var(--color-fondo-claro);
  }
}`, "",{"version":3,"sources":["webpack://./src/components/TrustedFeatures/TrustedFeatures.module.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,YAAA;EACA,0BAAA;EACA,kBAAA;AACJ;AACI;EANJ;IAOQ,qCAAA;IACA,gBAAA;IACA,MAAA;EAEN;AACF;;AAEI;EACI,6BAAA;AACR;;AAII;EACI,kDAAA;EACA,iBAAA;AADR;AAKI;EACI,kBAAA;EACA,gBAAA;EACA,8BAAA;AAHR;AAMI;EACI,SAAA;EACA,8BAAA;EACA,kBAAA;AAJR;AAOI;EACI;IACI,aAAA;IACA,cAAA;IACA,+CAAA;EALV;AACF","sourcesContent":[".grid {\n    display: grid;\n    gap: 1.25rem;\n    grid-template-columns: 1fr;\n    text-align: center;\n\n    @media (min-width: 768px) {\n        grid-template-columns: repeat(3, 1fr);\n        text-align: left;\n        gap: 0;\n    }\n}\n\n.trustedFeatures{\n    p {\n        font-size: var(--font-normal);\n    }\n}\n\n.item {\n    &+.item {\n        border-top: 1px solid var(--color-fondo-claro-200);\n        padding-top: 1rem;\n        \n    }\n\n    h6 {\n        margin: 0 0 .5rem;\n        font-weight: 700;\n        color: var(--color-secundario);\n    }\n\n    p {\n        margin: 0;\n        color: var(--color-secundario);\n        font-size: .95rem;\n    }\n\n    @media (min-width: 768px) {\n        &+.item {\n            border-top: 0;\n            padding-top: 0;\n            border-left: 1px solid var(--color-fondo-claro);\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"grid": `TrustedFeatures_grid__vkqBz`,
	"trustedFeatures": `TrustedFeatures_trustedFeatures__YOWxK`,
	"item": `TrustedFeatures_item__AiY+l`
};
export default ___CSS_LOADER_EXPORT___;
